import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRightLeft } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDateTime, statusLabel } from "@/lib/format";
import { Panel } from "@/components/common";
import { PROVIDER_LABEL, Row } from "@/pages/admin/migrations/shared";

export function MigrationSourcePanel({ courseId }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/migrations/courses/by-destination/${courseId}`).then((r) => setD(r.data)).catch(() => setD(null)); }, [courseId]);
  if (!d) return null;
  const m = d.migration, objs = d.objects || [];
  const unresolved = (d.reviews || []).filter((r) => r.status === "unresolved").length;
  const byStatus = objs.reduce((a, o) => { const k = o.status.startsWith("complete") ? "complete" : o.status; a[k] = (a[k] || 0) + 1; return a; }, {});
  return (
    <Panel title="Source information" padded testId="migration-source-panel">
      <div className="text-xs text-slate-500 mb-2 flex items-center gap-1.5"><ArrowRightLeft size={12} /> Migrated from {PROVIDER_LABEL[m.provider] || m.provider}{d.connection?.name ? ` · ${d.connection.name}` : ""}</div>
      <dl className="text-sm space-y-1.5">
        <Row k="Source course ID" v={m.sourceCourseId} mono />
        <Row k="Source code" v={m.sourceCode || "—"} mono />
        <Row k="Batch" v={<Link to={`/org/migrations/queue/${m.batchId}`} className="link" data-testid="source-panel-batch-link">#{m.batchNumber}</Link>} />
        <Row k="Migrated" v={fmtDateTime(m.migratedAt)} />
        <Row k="Source status" v={statusLabel(m.sourceStatus)} />
        <Row k="Source type" v={m.sourceCourseType} />
        <Row k="Objects" v={`${objs.length}${objs.length ? ` (${Object.entries(byStatus).map(([k, v]) => `${v} ${statusLabel(k)}`).join(", ")})` : ""}`} />
        <Row k="Open review items" v={unresolved ? <Link to={`/org/migrations/review?courseId=${courseId}`} className="link text-amber-700">{unresolved}</Link> : "0"} />
        {d.migrations?.length > 1 && <Row k="Migration runs" v={d.migrations.length} />}
      </dl>
      {d.sourceMetadata && <details className="mt-2 text-xs"><summary className="cursor-pointer text-slate-600">Raw source metadata</summary><pre className="mt-1 bg-slate-50 border rounded p-2 overflow-auto max-h-48 text-[11px]">{JSON.stringify(d.sourceMetadata, null, 2)}</pre></details>}
    </Panel>
  );
}
